import { ShippingMethod } from "inbounds/ShippingMethod";
import { SHIPPING_OPTION_TO_METHOD } from "inbounds/constants/shippingOptionToMethod";
import { InboundShipment } from "@deliverr/inbound-client";

export const getShippingMethodFromOption = (
  shippingOption: InboundShipment["shippingOption"]
): ShippingMethod | undefined => {
  return shippingOption ? SHIPPING_OPTION_TO_METHOD[shippingOption] : undefined;
};
